import cloneDeep from 'lodash.clonedeep';
import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';
import { Operation, AuditDetails } from 'data/types';
import { SecurityPolicy, SecurityPolicyFormData } from 'data/securityPolicy/securityPolicy.types';
import { NO_CONSECUTIVE_CHARACTERS_LIMIT, MAX_CONSECUTIVE_CHARACTERS_DEFAULT } from 'routes/SecurityPolicy/securityPolicyConstants';

export function getSecurityPolicyDataToSubmit(
  securityPolicyData: SecurityPolicyFormData,
): SecurityPolicy[] {

  const clonedData = cloneDeep(securityPolicyData);

  const {
    maxConsecutiveCharacters,
    allowNumericSequences,
    allowPasswordUsernameMatch,
    allowCurrentPasswordReuse
  } = clonedData.passwordSettings;
  if (maxConsecutiveCharacters) {
    clonedData.passwordSettings.maxConsecutiveCharacters = MAX_CONSECUTIVE_CHARACTERS_DEFAULT.toString();
  } else {
    clonedData.passwordSettings.maxConsecutiveCharacters = NO_CONSECUTIVE_CHARACTERS_LIMIT;
  }
  clonedData.passwordSettings.allowNumericSequences = String(!allowNumericSequences);
  clonedData.passwordSettings.allowPasswordUsernameMatch = String(!allowPasswordUsernameMatch);
  clonedData.passwordSettings.allowCurrentPasswordReuse = String(!allowCurrentPasswordReuse);

  const allPolicies = {
    ...clonedData.passwordSettings,
    ...clonedData.accountLockoutSettings,
    ...clonedData.ipAddressBlockingSettings
  };

  const payload = Object.entries(allPolicies).map(([key, value]) => ({
    name: String(key),
    value: String(value),
  }));

  return payload;
}

export function getSecurityPolicyAuditDetailsToSubmit(
  securityPolicyData: SecurityPolicy[],
  originalSecurityPolicyFormData: SecurityPolicy | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): AuditDetails {

  let actionType = AuditActionType.SECURITY_POLICY_ADD;
  let isEdit = false;
  if (operation === 'UPDATE') {
    actionType = AuditActionType.SECURITY_POLICY_EDIT;
    isEdit = true;
  }

  const auditDetails = getAuditDetails(
    isAuditEnabled,
    userId,
    userName,
    getAuditFieldInfo(securityPolicyData, null, isEdit, originalSecurityPolicyFormData),
    securityPolicyData[0].name,
    AuditService.SECURITY_POLICY,
    actionType,
  );
  return auditDetails as AuditDetails;
}
